// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.experience-card {
  position: relative;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 30px -15px;
  border-radius: 10px;
  border: 1px solid rgba(211, 211, 211, 0.397);
}

.experience-card-dark {
  position: relative;
  background-color: #171c28;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 30px -15px;
  border-radius: 10px;
  border: 1px solid rgba(211, 211, 211, 0.397);
}

.experience-card:hover {
  box-shadow: rgba(0, 0, 0, 0.2) 0px 20px 30px -10px;
}

.experience-banner {
  background-position: center;
  background-repeat: no-repeat;
  background-size: 150%;
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5));
  border-radius: 10px 10px 0px 0px;
  -moz-filter: blur(0px);
  -o-filter: blur(0px);
  -ms-filter: blur(0px);
  filter: blur(0px);
  height: 11rem;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.experience-blurred_div {
  position: absolute;
  background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2));
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  height: 11rem;
  top: 0;
  left: 0;
  width: 100%;
  border-radius: 10px 10px 0px 0px;
}

.experience-div-company {
  position: absolute;
  background: transparent;
  height: 9rem;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.experience-text-company {
  text-align: center;
  padding: 1.5rem;
  margin: 0;
  color: #fff;
  font-size: 25px;
  text-align: center;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.experience-roundedimg {
  position: absolute;
  object-fit: cover;
  left: 0;
  right: 0;
  top: 7rem;
  margin-left: auto;
  margin-right: auto;
  width: 8rem;
  height: 8rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  border-radius: 50%;
}

.experience-text-role {
  text-align: center;
  color: #000000;
  font-weight: 700;
  font-size: 25px;
  margin: 0px;
  padding-top: 1.5rem;
  line-height: normal;
}

.dark-mode-text {
  color: #ffffff !important;
}

.experience-text-date {
  text-align: center;
  color: #000000;
  font-size: 20px;
  margin: 0px;
  padding-top: 1rem;
  font-weight: 600;
}

.experience-text-desc {
  text-align: center;
}

.experience-text-details {
  padding: 1.5rem;
  margin-top: 2rem;
}

/* Media Query */
@media (max-width: 1380px) {
  .experience-text-role {
    padding-top: 0.5rem;
    font-size: 22px;
  }
  .experience-text-company {
    font-size: 22px;
  }
  .experience-text-date {
    font-size: 18px;
  }
  .experience-roundedimg {
    width: 6.5rem;
    height: 6.5rem;
  }
}
@media (max-width: 768px) {
  .experience-text-role {
    font-size: 22px;
  }
  .experience-text-company {
    font-size: 22px;
  }
  .experience-text-date {
    font-size: 18px;
  }
  .experience-text-desc {
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/components/experienceCard/ExperienceCard.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,kBAAA;EACA,oCD8BiB;EC7BjB,kDAAA;EACA,mBAAA;EACA,4CAAA;AAEF;;AACA;EACE,kBAAA;EACA,yBD0Be;ECzBf,kDAAA;EACA,mBAAA;EACA,4CAAA;AAEF;;AACA;EACE,kDAAA;AAEF;;AACA;EACE,2BAAA;EACA,4BAAA;EACA,qBAAA;EACA,mED4BuB;EC3BvB,gCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;AAEF;;AACA;EACE,kBAAA;EACA,mEDS2B;ECP3B,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,gCAAA;AAEF;;AACA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;;AACA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,WDrCiB;ECsCjB,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,iBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;EACA,kBAAA;AAEF;;AACA;EACE,kBAAA;EACA,cDpFU;ECqFV,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;;AADA;EACE,kBAAA;EACA,cDhGU;ECiGV,eAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AAIF;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,eAAA;EACA,gBAAA;AAIF;;AADA,gBAAA;AAEA;EACE;IACE,mBAAA;IACA,eAAA;EAGF;EADA;IACE,eAAA;EAGF;EADA;IACE,eAAA;EAGF;EADA;IACE,aAAA;IACA,cAAA;EAGF;AACF;AAAA;EACE;IACE,eAAA;EAEF;EAAA;IACE,eAAA;EAEF;EAAA;IACE,eAAA;EAEF;EAAA;IACE,eAAA;EAEF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.experience-card {\n  position: relative;\n  background-color: $lightBackground2;\n  box-shadow: $lightBoxShadowDark 0px 10px 30px -15px;\n  border-radius: 10px;\n  border: 1px solid $lightBorder1;\n}\n\n.experience-card-dark {\n  position: relative;\n  background-color: $darkBackground;\n  box-shadow: $lightBoxShadowDark 0px 10px 30px -15px;\n  border-radius: 10px;\n  border: 1px solid $lightBorder1;\n}\n\n.experience-card:hover {\n  box-shadow: $lightBoxShadowDark 0px 20px 30px -10px;\n}\n\n.experience-banner {\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 150%;\n  background: $experienceCardBannerLG;\n  border-radius: 10px 10px 0px 0px;\n  -webkit-filter: blur(0px);\n  -moz-filter: blur(0px);\n  -o-filter: blur(0px);\n  -ms-filter: blur(0px);\n  filter: blur(0px);\n  height: 11rem;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.experience-blurred_div {\n  position: absolute;\n  background: $experienceCardBlurredDivLG;\n  -webkit-filter: blur(5px);\n  -moz-filter: blur(5px);\n  -o-filter: blur(5px);\n  -ms-filter: blur(5px);\n  filter: blur(5px);\n  height: 11rem;\n  top: 0;\n  left: 0;\n  width: 100%;\n  border-radius: 10px 10px 0px 0px;\n}\n\n.experience-div-company {\n  position: absolute;\n  background: transparent;\n  height: 9rem;\n  top: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.experience-text-company {\n  text-align: center;\n  padding: 1.5rem;\n  margin: 0;\n  color: $lightBackground1;\n  font-size: 25px;\n  text-align: center;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.experience-roundedimg {\n  position: absolute;\n  object-fit: cover;\n  left: 0;\n  right: 0;\n  top: 7rem;\n  margin-left: auto;\n  margin-right: auto;\n  width: 8rem;\n  height: 8rem;\n  box-shadow: 0 0.5rem 1rem $lightBoxShadowDarker;\n  border-radius: 50%;\n}\n\n.experience-text-role {\n  text-align: center;\n  color: $textColor;\n  font-weight: 700;\n  font-size: 25px;\n  margin: 0px;\n  padding-top: 1.5rem;\n  line-height: normal;\n}\n.dark-mode-text {\n  color: $textColorDark !important;\n}\n.experience-text-date {\n  text-align: center;\n  color: $textColor;\n  font-size: 20px;\n  margin: 0px;\n  padding-top: 1rem;\n  font-weight: 600;\n}\n\n.experience-text-desc {\n  text-align: center;\n}\n\n.experience-text-details {\n  padding: 1.5rem;\n  margin-top: 2rem;\n}\n\n/* Media Query */\n\n@media (max-width: 1380px) {\n  .experience-text-role {\n    padding-top: 0.5rem;\n    font-size: 22px;\n  }\n  .experience-text-company {\n    font-size: 22px;\n  }\n  .experience-text-date {\n    font-size: 18px;\n  }\n  .experience-roundedimg {\n    width: 6.5rem;\n    height: 6.5rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .experience-text-role {\n    font-size: 22px;\n  }\n  .experience-text-company {\n    font-size: 22px;\n  }\n  .experience-text-date {\n    font-size: 18px;\n  }\n  .experience-text-desc {\n    font-size: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
